export default class CssUtility {

	/**
	 * @returns {{}}
	 */
	static getModalStyles() {
		return {
			overlay : {
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				zIndex: 100,
				backgroundColor: 'rgba(255, 255, 255, 0.75)'
			},
			content: {
				top: '50%',
				left: '50%',
				right: 'auto',
				bottom: 'auto',
				zIndex: 100,
				marginRight: '-50%',
				transform: 'translate(-50%, -50%)',
				padding: '5px',
				borderRadius: 0
			}
		};
	}

}